import { motion } from 'framer-motion';
import { fadeUp } from './data';

export const SectionHeading = ({ eyebrow, children, className = "mb-14 md:mb-16" }) => (
  <div className={`max-w-4xl mx-auto px-6 md:px-12 text-center ${className}`}>
    <motion.p {...fadeUp} className="text-[#d6cdb4] text-sm tracking-[0.25em] uppercase mb-6">
      {eyebrow}
    </motion.p>
    <motion.h2 {...fadeUp} className="text-3xl md:text-5xl text-white font-light leading-tight">
      {children}
    </motion.h2>
  </div>
);

export const ImageTag = ({ children }) => (
  <span className="absolute top-3 left-3 bg-black/60 backdrop-blur-sm text-white/90 text-[11px] tracking-[0.12em] uppercase px-2.5 py-1">
    {children}
  </span>
);
